/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSign.vue?vue&type=template&id=b324a8cc&scoped=true"
import script from "./popSign.vue?vue&type=script&lang=js"
export * from "./popSign.vue?vue&type=script&lang=js"
import style0 from "./popSign.vue?vue&type=style&index=0&id=b324a8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324a8cc",
  null
  
)

export default component.exports